// import leanProduct from "../../assets/resources/leanProduct.png";
// import pmToolkit from "../../assets/resources/pmToolKit.png";
// import productLead from "../../assets/resources/productLeadership.png";
import keys from "../../assets/resources/keys.png";
import job from "../../assets/resources/job.png";
import earn from "../../assets/resources/earn.png"
import playbook from "../../assets/resources/tech.png"
import abc from "../../assets/resources/abc.png"

export const BookData = [
    {
        imgUrl: abc,
        bookUrl: "/abc.pdf",
        form : "https://birdsend.page/forms/6444/X9oCX79DLk"
    },
    {
        imgUrl: playbook,
        bookUrl: "/playbook.pdf",
        form : "https://birdsend.page/forms/6444/DcVP2mTzH4"
    },
    {
        imgUrl: job,
        bookUrl: "/job.pdf",
        form : "https://birdsend.page/forms/6444/58x4F3SB4M"
    },
    {
        imgUrl: earn,
        bookUrl:"/earn.pdf",
        form : "https://birdsend.page/forms/6444/PwvL1h6qIh"
    },
    {
        imgUrl: keys,
        bookUrl: "/keys.pdf",
        form : "https://birdsend.page/forms/6444/le1TpBkDuc"
    }
]